import { useFlag } from '@unleash/proxy-client-react'

// Single source of truth for the Coach Workspace feature flag (ENG-3306). ONE
// flag gates the whole project -- coach relationships, coaching meetings, coach
// availability, coach-to-learner messaging and the coach learner profile all
// read this constant, never a repeated string literal. The backend member is
// `Flags.COACH_WORKSPACE` in backend/app/unleash_flags.py and must stay
// byte-identical to this value.
//
// ROUTED SURFACES MUST NOT USE THIS HOOK TO DECIDE ACCESS. Wrap them in
// <CoachWorkspaceGuard> from src/components/guards/CoachWorkspaceGuard.tsx
// instead, which is pre-bound to this constant so a route cannot be gated on a
// mistyped string. It delegates to FeatureFlagGuard, the only place that waits
// on `flagsReady && useUnleashUserContextReady()` before deciding, and this flag
// is targeted per user, so on a hard page load `useFlag` reports a spurious
// false until the Clerk context push lands. A hand-rolled `useFlag` + redirect
// bounces a pilot coach off their own page on every refresh.
//
// Use this hook only for in-page conditionals (hiding a tab, a card, a CTA)
// where a transient false renders nothing rather than navigating away.
//
// Note the frontend/backend userId identity mismatch: a userWithId strategy must
// list both the Clerk id and the database uuid for the same person, or this hook
// and the API disagree about whether the flag is on.
export const COACH_WORKSPACE_FEATURE_FLAG = 'coach-workspace'

export function useCoachWorkspaceEnabled(): boolean {
  return useFlag(COACH_WORKSPACE_FEATURE_FLAG)
}
